/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type CreateViewPathParams = NonNullable<operations['createView']['parameters']['path']>;

export type CreateViewRequestBody = OperationRequestBodyContent<operations['createView']>;

export interface Input extends CreateViewPathParams {
  apiVersion?: string;
  body: CreateViewRequestBody;
  header: NonNullable<operations['createView']['parameters']['header']>;
}

export async function createView(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/views', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
